import { render, staticRenderFns } from "./RenderCargaActionTrash.vue?vue&type=template&id=f058dd78&scoped=true"
import script from "./RenderCargaActionTrash.vue?vue&type=script&lang=ts"
export * from "./RenderCargaActionTrash.vue?vue&type=script&lang=ts"
import style0 from "./RenderCargaActionTrash.vue?vue&type=style&index=0&id=f058dd78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f058dd78",
  null
  
)

export default component.exports